<mat-card
    class="daxa-card recent-orders-card border-radius bg-white border-none d-block p-3"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined"> search </i>
                <input type="text" class="input-search d-block w-100 border-0 outline-0 rounded-pill"
                       placeholder="Chercher un échantillon..." (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <div class="btn-group">
                <button class="btn btn-outline-primary btn-sm rounded-start-pill" (click)="openModal(content)">
                    <i class="fa-solid fa-plus px-2"></i> Nouveau
                </button>
                <button class="btn btn-outline-primary btn-sm rounded-end-pill" [matMenuTriggerFor]="menu"
                    aria-haspopup="true" aria-expanded="false" id="dropdownMenuClickableInside">
                    <i class="fa-solid fa-sliders px-2"></i>
                </button>
            </div>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>

                  <!-- Code échantillon -->
                  <ng-container matColumnDef="sampleCode">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Code </th>
                    <td mat-cell *matCellDef="let element"> {{ element.sampleCode }} </td>
                  </ng-container>
                  <ng-container matColumnDef="departementName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Département </th>
                    <td mat-cell *matCellDef="let element"> {{ element.departementName }} </td>
                  </ng-container>
                  <!-- Type d'échantillon -->
                  <ng-container matColumnDef="typeSampleName">
                    <th mat-header-cell *matHeaderCellDef> Type </th>
                    <td mat-cell *matCellDef="let element"> {{ element.typeSampleName }} </td>
                  </ng-container>

                  <!-- Client -->
                  <ng-container matColumnDef="clientName">
                    <th mat-header-cell *matHeaderCellDef> Client </th>
                    <td mat-cell *matCellDef="let element"> {{ element.clientName }} </td>
                  </ng-container>

                  <!-- Lot -->
                  <ng-container matColumnDef="batchReference">
                    <th mat-header-cell *matHeaderCellDef> Lot </th>
                    <td mat-cell *matCellDef="let element"> {{ element.batchReference }} </td>
                  </ng-container>

                  <!-- Terrain -->
                  <ng-container matColumnDef="terrainVarPlante">
                    <th mat-header-cell *matHeaderCellDef> Terrain </th>
                    <td mat-cell *matCellDef="let element"> {{ element.terrainVarPlante }} </td>
                  </ng-container>

                  <!-- Prélevé par -->
                  <ng-container matColumnDef="collectedByUsername">
                    <th mat-header-cell *matHeaderCellDef> Prélevé par </th>
                    <td mat-cell *matCellDef="let element"> {{ element.collectedByUsername }} </td>
                  </ng-container>

                  <!-- Quantité prélevée -->
                  <ng-container matColumnDef="qtePre">
                    <th mat-header-cell *matHeaderCellDef> Quantité </th>
                    <td mat-cell *matCellDef="let element"> {{ element.qtePre }} </td>
                  </ng-container>

                  <!-- Date de collecte -->
                  <ng-container matColumnDef="collectionDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Date collecte </th>
                    <td mat-cell *matCellDef="let element"> {{ element.collectionDate |  date:'dd/MM/yyyy HH:mm'  }} </td>
                  </ng-container>
                  <!-- Température prélèvement -->
                  <ng-container matColumnDef="temperaturePrelevement">
                    <th mat-header-cell *matHeaderCellDef> Température </th>
                    <td mat-cell *matCellDef="let element"> {{ element.temperaturePrelevement }} </td>
                  </ng-container>

                  <!-- Date production -->
                  <ng-container matColumnDef="dateProduction">
                    <th mat-header-cell *matHeaderCellDef> Date production </th>
                    <td mat-cell *matCellDef="let element"> {{ element.dateProduction  }} </td>
                  </ng-container>

                  <!-- Date limite consommation -->
                  <ng-container matColumnDef="dateLimiteConsommation">
                    <th mat-header-cell *matHeaderCellDef> DLC </th>
                    <td mat-cell *matCellDef="let element"> {{ element.dateLimiteConsommation }} </td>
                  </ng-container>
                  <ng-container matColumnDef="matriceNom">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Matrice </th>
                    <td mat-cell *matCellDef="let element"> {{ element.matriceName || '-' }} </td>
                  </ng-container>

                  <!-- Type d'analyse -->
                  <ng-container matColumnDef="typeAnalyseCode">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Type d'analyse </th>
                    <td mat-cell *matCellDef="let element"> {{ element.typeAnalyseName || '-' }} </td>
                  </ng-container>

  <!-- Désignation -->
                  <ng-container matColumnDef="designation">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Désignation </th>
                    <td mat-cell *matCellDef="let element"> {{ element.designation || '-' }} </td>
                  </ng-container>

                  <!-- Priorité -->
                  <ng-container matColumnDef="priorite">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Priorité </th>
                    <td mat-cell *matCellDef="let element"> {{ element.priorite || '-' }} </td>
                  </ng-container>

                  <!-- Scellé -->
                  <ng-container matColumnDef="scelle">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Scellé </th>
                    <td mat-cell *matCellDef="let element"> {{ element.scelle ? '✅' : '❌' }} </td>
                  </ng-container>
                  <ng-container matColumnDef="accredited">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Echnatillon accrédité </th>
                    <td mat-cell *matCellDef="let element"> {{ element.accredited ? '✅' : '❌' }} </td>
                  </ng-container>
                  <ng-container matColumnDef="preleveParClient">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Prelvé Par Client </th>
                    <td mat-cell *matCellDef="let element"> {{ element.preleveParClient ? '✅' : '❌' }} </td>
                  </ng-container>
                  <!-- Conditionnement -->
                  <ng-container matColumnDef="conditionnement">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Conditionnement </th>
                    <td mat-cell *matCellDef="let element"> {{ element.conditionnement || '-' }} </td>
                  </ng-container>

                  <!-- Actions -->
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="text-center"> Action </th>
                    <td mat-cell *matCellDef="let element">
                      <div class="action-info text-center">
                        <button mat-button (click)="openViewSample(element)">
                          <i class="material-symbols-outlined">visibility</i>
                        </button>
                      <button
                        mat-button
                        matTooltip="Réception de l’échantillon"
                        (click)="openReceptionModal(element)">
                      
                       <mat-icon color="primary">assignment_turned_in</mat-icon>
                    </button>

                        <button mat-button (click)="editSample(element)">
                          <i class="material-symbols-outlined text-primary">brush</i>
                        </button>
                        <button mat-button (click)="confirmDelete(element)">
                          <i class="material-symbols-outlined text-danger">delete</i>
                        </button>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

          <div *ngIf="loadingTable">
            <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                <span class="skeleton-cell"></span>
            </div>
          </div>
          </div>
          <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
          </div>
    </mat-card-content>
</mat-card>


<ng-template #content let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    <mat-card-header>
      <mat-card-title>
        <h5 class="mt-0 mb-0">Créer un Prélèvement</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>

      <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="row">
        <div *ngIf="selectedLotId && selectedLotId > 0">
                        <p *ngIf="getRemainingSamples(selectedLotId) > 0" class="alert alert-info" style="margin-bottom:15px">
                            Vous pouvez encore ajouter
                            <strong>{{ getRemainingSamples(selectedLotId) }}</strong> 
                            échantillon(s) a ce lot.
                        </p>
                          
                        <p *ngIf="getRemainingSamples(selectedLotId) <= 0" class="alert alert-danger" style="margin-bottom:15px">
                            Ce lot a atteint le <strong>nombre maximal</strong> d’échantillons autorisés. 
                            Vous ne pouvez plus en ajouter.
                        </p>
                    </div>

          <!-- Type d'échantillon -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Type d'échantillon</mat-label>
              <mat-select formControlName="typeSampleName" required>
                <mat-option *ngFor="let type of sampleTypes" [value]="type">
                  {{ type }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('typeSampleName')?.hasError('required')">
                Type requis
              </mat-error>
            </mat-form-field>
          </div>
          <!-- Lot -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
    <mat-label>Référence du lot</mat-label>
    <input matInput placeholder="Entrez la référence du lot" formControlName="batchReference">
  </mat-form-field>
          </div>
          <!-- Client -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Client</mat-label>
              <mat-select
                formControlName="clientId"
                [compareWith]="compareById"
                required
              >
                <mat-option *ngFor="let client of clientList" [value]="client.id">
                  {{ client.socialReason }}
                </mat-option>
              </mat-select>

              <mat-error *ngIf="form.get('clientId')?.hasError('required')">Client requis</mat-error>
            </mat-form-field>
          </div>


          <!-- Terrain -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Terrain</mat-label>
              <mat-select formControlName="terrainId">
                <mat-option *ngFor="let terrain of terrainList" [value]="terrain.id">
                  {{ terrain.varPlante }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Prélevé par -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Prélevé par</mat-label>
              <mat-select formControlName="collectedById" required>
                <mat-option *ngFor="let user of preleveurs" [value]="user.id">
                  {{ user.name }} - {{ user.prenom }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-sm-12 col-md-6">
              <mat-form-field class="mb-3">
                <mat-label>Quantité</mat-label>

                <!-- input يعرض القيمة + الوحدة -->
                <input matInput
                      [value]="displayValue + ' ' + selectedUnit"
                      (input)="onValueChange($event)">

                  <!-- اختيار الوحدة -->
                <mat-select matSuffix
                            [(value)]="selectedUnit"
                            (selectionChange)="updateCombined()"
                            class="unit-select">

                  <!-- Masse -->
                  <mat-option value="kg">kg</mat-option>
                  <mat-option value="g">g</mat-option>
                  <mat-option value="mg">mg</mat-option>
                  <mat-option value="µg">µg</mat-option>

                  <!-- Volume -->
                  <mat-option value="L">L</mat-option>
                  <mat-option value="mL">mL</mat-option>
                  <mat-option value="µL">µL</mat-option>

                  <!-- Concentration -->
                  <mat-option value="mg/L">mg/L</mat-option>

                </mat-select>
              </mat-form-field>
          </div>
          <!--
<div class="col-sm-12 col-md-6">
  <mat-form-field appearance="outline" class="mb-3 w-100">
    <mat-label>Date et heure de prélèvement</mat-label>
    <input
      matInput
      [ngxMatDatetimePicker]="pickerCollection"
      formControlName="collectionDate"
      placeholder="JJ/MM/AAAA HH:mm"
      required
    />
    <ngx-mat-datepicker-toggle matSuffix [for]="pickerCollection"></ngx-mat-datepicker-toggle>

    <ngx-mat-datetime-picker
      #pickerCollection
      [showSpinners]="true"
      [stepHour]="1"
      [stepMinute]="5"
      [showSeconds]="false"
      [touchUi]="false"
      color="primary"
      class="custom-datetime-picker"
    >
    </ngx-mat-datetime-picker>

    <mat-error *ngIf="form.get('collectionDate')?.hasError('required')">
      Date et heure requises
    </mat-error>
  </mat-form-field>
</div>-->
          <!-- Date de collecte -->
        <div class="col-sm-12 col-md-6">
          <mat-form-field class="mb-3">
            <mat-label>Date et heure de prélèvement</mat-label>
            <input matInput type="datetime-local" formControlName="collectionDate" required>
            <mat-error *ngIf="form.get('collectionDate')?.hasError('required')">Date et heure requises</mat-error>
          </mat-form-field>
        </div>

          <!-- Température prélèvement -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Température prélèvement</mat-label>
              <input matInput type="text" formControlName="temperaturePrelevement">
            </mat-form-field>
          </div>

          <!-- Date production -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Date de production</mat-label>
              <input matInput [matDatepicker]="pickerProd" formControlName="dateProduction">
              <mat-datepicker-toggle matSuffix [for]="pickerProd"></mat-datepicker-toggle>
              <mat-datepicker #pickerProd></mat-datepicker>
            </mat-form-field>
          </div>

          <!-- Date limite consommation -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Date limite consommation</mat-label>
              <input matInput [matDatepicker]="pickerDLC" formControlName="dateLimiteConsommation">
              <mat-datepicker-toggle matSuffix [for]="pickerDLC"></mat-datepicker-toggle>
              <mat-datepicker #pickerDLC></mat-datepicker>
            </mat-form-field>
          </div>
          <!-- Désignation -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Désignation</mat-label>
              <input matInput type="text" formControlName="designation">
            </mat-form-field>
          </div>

          <!-- Scellé -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Scellé</mat-label>
              <mat-select formControlName="scelle">
                <mat-option [value]="true">Oui</mat-option>
                <mat-option [value]="false">Non</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Echnatillon accredité</mat-label>
              <mat-select formControlName="accredited">
                <mat-option [value]="true">Oui</mat-option>
                <mat-option [value]="false">Non</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
           <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Prelvé par client</mat-label>
              <mat-select formControlName="preleveParClient">
                <mat-option [value]="true">Oui</mat-option>
                <mat-option [value]="false">Non</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Conditionnement -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Conditionnement</mat-label>
              <mat-select formControlName="conditionnement">
                <mat-option value="Pot stérile">Pot stérile</mat-option>
                <mat-option value="Sachet stomacher">Sachet stomacher</mat-option>
                <mat-option value="Flacon">Flacon</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Priorité -->
 <div class="col-sm-12 col-md-6">
  <mat-form-field class="mb-3">
    <mat-label>Priorité</mat-label>
    <mat-select formControlName="priorite">
      <mat-option value="STANDARD">Standard</mat-option>
      <mat-option value="URGENCE">Urgence</mat-option>
    </mat-select>
  </mat-form-field>
</div>
          <!--
          <div class="col-sm-12 col-md-6">
              <mat-form-field class="mb-3">
              <mat-label>Départements</mat-label>
              <mat-select id="departments" formControlName="departmentIds" multiple>
                <mat-option *ngFor="let dep of departments" [value]="dep.id">
                  {{ dep.name }}
               </mat-option>
              </mat-select>            
            </mat-form-field>
          </div>
-->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Matrice</mat-label>
              <mat-select formControlName="matriceId" placeholder="Sélectionner la matrice"
                          >
                <mat-option *ngFor="let mat of filteredMatrices" [value]="mat.id">{{ mat.nom }}</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('matriceId')?.hasError('required')">Champ requis</mat-error>
            </mat-form-field>
          </div>

          <!-- Type d'analyse -->
        <div class="col-sm-12 col-md-6">
          <mat-form-field class="mb-3">
            <mat-label>Types d'analyse</mat-label>
            <mat-select formControlName="typeAnalyseId" multiple (openedChange)="onTypeAnalyseOpened($event)">
              <mat-option *ngFor="let ta of typeAnalyseList" [value]="ta.id">
                {{ ta.codeAT }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('typeAnalyseId')?.hasError('required')">
              Au moins un type d'analyse doit être sélectionné
            </mat-error>
          </mat-form-field>
        </div>

          <!-- Paramètres 
          <div class="col-sm-12 pt-3 border-top p-3">
            <div class="fw-bold">Paramètres :</div>
            <div *ngIf="!form.value.matriceId || !form.value.typeAnalyseId">
              Sélectionnez une matrice et un type d'analyse pour voir les paramètres.
            </div>
            <div *ngIf="form.value.matriceId && form.value.typeAnalyseId">
              <div *ngIf="paramList.length === 0">Aucun paramètre disponible pour ce type d'analyse.</div>
              <div *ngFor="let param of paramList; trackBy: trackByFn">
                <div class="row mt-3">
                  <div class="col-sm-6 col-lg-3">
                    <div class="fw-bold">Code Paramètre :</div>
                    <p>{{ param.codeParameter || param.pesticideName || 'N/A' }}</p>
                  </div>
                  <div class="col-sm-6 col-lg-3">
                    <div class="fw-bold">Norme :</div>
                    <p>{{ param.description || 'N/A' }}</p>
                  </div>
                  <div class="col-sm-6 col-lg-3">
                    <div class="fw-bold">Description :</div>
                    <p>{{ param.norme || 'N/A' }}</p>
                  </div>
                  <div class="col-sm-6 col-lg-3">
                    <div class="fw-bold">Technique :</div>
                    <p>{{ param.technique || 'N/A' }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>-->
          <!-- Bouton d'enregistrement -->
          <div class="col-sm-12 text-right mt-3">
            <button type="submit" class="btn btn-outline-success">Enregistrer</button>
          </div>

        </div>
      </form>
    </mat-card-content>
  </mat-card>
</ng-template>

<ng-template #receptionModal let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    <mat-card-header>
      <mat-card-title>
        <h5 class="mt-0 mb-0">Réception de l’échantillon</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="receptionForm" (ngSubmit)="submitReception(modal)">
        <div class="row">
          <!-- Date et heure réception -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Date et heure réception</mat-label>
              <input matInput type="datetime-local" formControlName="dateReception" required>
            </mat-form-field>
          </div>

          <!-- Température -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Température réception</mat-label>
              <input matInput formControlName="temperatureReception">
            </mat-form-field>
          </div>
    <div class="col-sm-12 col-md-6">
      <mat-form-field class="mb-3 w-100">
        <mat-label>Méthode d’analyse</mat-label>
        <mat-select formControlName="methodeId" required>

          <mat-option *ngFor="let m of availableMethodes"
                      [value]="m.id">
            {{ m.name }} ({{ m.code }})
          </mat-option>

        </mat-select>

        <mat-hint *ngIf="availableMethodes.length === 0" class="text-danger">
          Aucune méthode disponible pour ce type d’analyse
        </mat-hint>
      </mat-form-field>
    </div>
          <!-- Volume -->
          <div class="col-sm-12 col-md-6">
  <mat-form-field class="mb-3">
    <mat-label>Volume</mat-label>

    <!-- input يعرض القيمة + الوحدة -->
    <input matInput
           [value]="displayVolume + ' ' + selectedVolumeUnit"
           (input)="onVolumeChange($event)">

    <!-- اختيار وحدة الحجم -->
    <mat-select matSuffix
                [(value)]="selectedVolumeUnit"
                (selectionChange)="updateVolumeCombined()"
                class="unit-select">

      
                  <!-- Masse -->
                  <mat-option value="kg">kg</mat-option>
                  <mat-option value="g">g</mat-option>
                  <mat-option value="mg">mg</mat-option>
                  <mat-option value="µg">µg</mat-option>

                  <!-- Volume -->
                  <mat-option value="L">L</mat-option>
                  <mat-option value="mL">mL</mat-option>
                  <mat-option value="µL">µL</mat-option>

                  <!-- Concentration -->
                  <mat-option value="mg/L">mg/L</mat-option>

    </mat-select>

  </mat-form-field>
</div>
<div class="col-sm-12 col-md-6">
  <mat-form-field class="mb-3">
    <mat-label>Conditionnement de réception</mat-label>
    <mat-select formControlName="conditionnementReception" required (selectionChange)="onConditionnementChange($event.value)">
      <mat-option value="Conforme">Conforme</mat-option>
      <mat-option value="Non conforme">Non conforme</mat-option>
    </mat-select>
  </mat-form-field>
</div>

<!-- Remarques (affiché seulement si Non conforme) -->
<!-- Propreté / contamination -->
        <div class="col-sm-12 col-md-6" *ngIf="showRemarques">
          <mat-form-field class="mb-3">
            <mat-label>Propreté / Contamination visible</mat-label>
            <mat-select formControlName="propreteContamination" >
              <mat-option value="Oui">Oui</mat-option>
              <mat-option value="Non">Non</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
<!-- Volume suffisant -->
        <div class="col-sm-12 col-md-6" *ngIf="showRemarques">
          <mat-form-field class="mb-3">
            <mat-label>Volume suffisant</mat-label>
            <mat-select formControlName="volumeSuffisant">
              <mat-option value="Oui">Oui</mat-option>
              <mat-option value="Non">Non</mat-option>
            </mat-select>
          </mat-form-field>
          </div>
<!-- Étiquetage lisible -->
          <div class="col-sm-12 col-md-6" *ngIf="showRemarques">
            <mat-form-field class="mb-3">
              <mat-label>Étiquetage lisible</mat-label>
              <mat-select formControlName="etiquetageLisible">
                <mat-option value="Oui">Oui</mat-option>
                <mat-option value="Non">Non</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
<!-- Scellé intact -->
          <div class="col-sm-12 col-md-6" *ngIf="showRemarques">
            <mat-form-field class="mb-3">
              <mat-label>Scellé intact</mat-label>
              <mat-select formControlName="scelleIntact">
                <mat-option value="Oui">Oui</mat-option>
                <mat-option value="Non">Non</mat-option>
                <mat-option value="Non Applicable">Non Applicable</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Bouton d'enregistrement -->
          <div class="col-sm-12 text-end mt-3">
            <button type="button" class="btn btn-outline-success me-2"
                    (click)="submitReception(true)">
              Valider
            </button>
            <button type="button" class="btn btn-outline-danger"
                    (click)="submitReception(false)">
              Rejeter
            </button>
          </div>

        </div>
      </form>
    </mat-card-content>
  </mat-card>
</ng-template>


<ng-template #editModal let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    <mat-card-header>
      <mat-card-title>
        <h5 class="mt-0 mb-0">Mettre à jour un Prélèvement</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="updatePrelevement()">
        <div class="row">

          <!-- Type d'échantillon -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Type d'échantillon</mat-label>
              <mat-select formControlName="typeSampleName" required>
                <mat-option *ngFor="let type of sampleTypes" [value]="type">
                  {{ type }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('typeSampleName')?.hasError('required')">
                Type requis
              </mat-error>
            </mat-form-field>
          </div>
          
          <!-- Client -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Client</mat-label>
              <mat-select formControlName="clientId" required>
                <mat-option *ngFor="let client of clientList" [value]="client.id">
                  {{ client.socialReason }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('clientId')?.hasError('required')">Client requis</mat-error>
            </mat-form-field>
          </div>

          <!-- Lot -->
          <div class="col-sm-12 col-md-6">
          <mat-form-field class="mb-3">
            <mat-label>Référence du lot</mat-label>
            <input matInput placeholder="Entrez la référence du lot" formControlName="batchReference">
          </mat-form-field>
        </div>


          <!-- Terrain -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Terrain</mat-label>
              <mat-select formControlName="terrainId">
                <mat-option *ngFor="let terrain of terrainList" [value]="terrain.id">
                  {{ terrain.varPlante }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Prélevé par -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Prélevé par</mat-label>
              <mat-select formControlName="collectedById" required>
                <mat-option *ngFor="let user of preleveurs" [value]="user.id">
                  {{ user.name }} {{ user.prenom }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('collectedById')?.hasError('required')">Utilisateur requis</mat-error>
            </mat-form-field>
          </div>

          <!-- Quantité -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Quantité</mat-label>
              <input matInput type="text" formControlName="qtePre" required>
              <mat-error *ngIf="form.get('qtePre')?.hasError('required')">Quantité requise</mat-error>
            </mat-form-field>
          </div>

          <!-- Date de collecte -->
        <div class="col-sm-12 col-md-6">
          <mat-form-field class="mb-3">
            <mat-label>Date et heure de prélèvement</mat-label>
            <input matInput type="datetime-local" formControlName="collectionDate" required>
            <mat-error *ngIf="form.get('collectionDate')?.hasError('required')">Date et heure requises</mat-error>
          </mat-form-field>
        </div>


          <!-- Température prélèvement -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Température prélèvement</mat-label>
              <input matInput type="text" formControlName="temperaturePrelevement">
            </mat-form-field>
          </div>

          <!-- Date production -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Date de production</mat-label>
              <input matInput [matDatepicker]="pickerProd" formControlName="dateProduction">
              <mat-datepicker-toggle matSuffix [for]="pickerProd"></mat-datepicker-toggle>
              <mat-datepicker #pickerProd></mat-datepicker>
            </mat-form-field>
          </div>

          <!-- Date limite consommation -->
          <div class="col-sm-12 col-md-6">
            <mat-form-field class="mb-3">
              <mat-label>Date limite consommation</mat-label>
              <input matInput [matDatepicker]="pickerDLC" formControlName="dateLimiteConsommation">
              <mat-datepicker-toggle matSuffix [for]="pickerDLC"></mat-datepicker-toggle>
              <mat-datepicker #pickerDLC></mat-datepicker>
            </mat-form-field>
          </div>
<div class="col-sm-12 col-md-6">
      <mat-form-field class="mb-3">
        <mat-label>Désignation</mat-label>
        <input matInput type="text" formControlName="designation">
      </mat-form-field>
    </div>

    <!-- Scellé -->
    <div class="col-sm-12 col-md-6">
      <mat-form-field class="mb-3">
        <mat-label>Scellé</mat-label>
        <mat-select formControlName="scelle">
          <mat-option [value]="true">Oui</mat-option>
          <mat-option [value]="false">Non</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-sm-12 col-md-6">
      <mat-form-field class="mb-3">
        <mat-label>Echnatillon Accredité</mat-label>
        <mat-select formControlName="accredited">
          <mat-option [value]="true">Oui</mat-option>
          <mat-option [value]="false">Non</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-sm-12 col-md-6">
      <mat-form-field class="mb-3">
        <mat-label>Prelevé par client</mat-label>
        <mat-select formControlName="preleveParClient">
          <mat-option [value]="true">Oui</mat-option>
          <mat-option [value]="false">Non</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Conditionnement -->
    <div class="col-sm-12 col-md-6">
      <mat-form-field class="mb-3">
        <mat-label>Conditionnement</mat-label>
        <mat-select formControlName="conditionnement">
          <mat-option value="Pot stérile">Pot stérile</mat-option>
          <mat-option value="Sachet stomacher">Sachet stomacher</mat-option>
          <mat-option value="Flacon">Flacon</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Priorité -->
    <div class="col-sm-12 col-md-6">
  <mat-form-field class="mb-3" >
    <mat-label>Priorité</mat-label>
    <mat-select formControlName="priorite">
      <mat-option value="STANDARD">Standard</mat-option>
      <mat-option value="URGENCE">Urgence</mat-option>
    </mat-select>
  </mat-form-field>
</div>
    <!-- Matrice -->
    <div class="col-sm-12 col-md-6">
      <mat-form-field class="mb-3">
        <mat-label>Matrice</mat-label>
        <mat-select formControlName="matriceId">
          <mat-option *ngFor="let mat of filteredMatrices" [value]="mat.id">{{ mat.nom }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('matriceId')?.hasError('required')">Champ requis</mat-error>
      </mat-form-field>
    </div>

    <!-- Type d'analyse -->
    <div class="col-sm-12 col-md-6">
      <mat-form-field class="mb-3">
        <mat-label>Type d'analyse</mat-label>
        <mat-select formControlName="typeAnalyseId">
          <mat-option *ngFor="let ta of typeAnalyseList" [value]="ta.id">{{ ta.codeAT }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('typeAnalyseId')?.hasError('required')">Champ requis</mat-error>
      </mat-form-field>
    </div>

    <!-- Paramètres 
    <div class="col-sm-12 pt-3 border-top p-3">
      <div class="fw-bold">Paramètres :</div>
      <div *ngIf="!form.value.matriceId || !form.value.typeAnalyseId">
        Sélectionnez une matrice et un type d'analyse pour voir les paramètres.
      </div>
      <div *ngIf="form.value.matriceId && form.value.typeAnalyseId">
        <div *ngIf="paramList.length === 0">Aucun paramètre disponible pour ce type d'analyse.</div>
        <div *ngFor="let param of paramList; trackBy: trackByFn">
          <div class="row mt-3">
            <div class="col-sm-6 col-lg-3">
              <div class="fw-bold">Code Paramètre :</div>
              <p>{{ param.codeParameter || param.pesticideName || 'N/A' }}</p>
            </div>
            <div class="col-sm-6 col-lg-3">
              <div class="fw-bold">Norme :</div>
              <p>{{ param.description || 'N/A' }}</p>
            </div>
            <div class="col-sm-6 col-lg-3">
              <div class="fw-bold">Description :</div>
              <p>{{ param.norme || 'N/A' }}</p>
            </div>
            <div class="col-sm-6 col-lg-3">
              <div class="fw-bold">Technique :</div>
              <p>{{ param.technique || 'N/A' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
-->
          <!-- Bouton de mise à jour -->
          <div class="col-sm-12 text-right mt-3">
            <button type="submit" class="btn btn-outline-primary">Mettre à jour</button>
          </div>

        </div>
      </form>
    </mat-card-content>
  </mat-card>
</ng-template>


<!-- Modal template for infos -->
<ng-template #viewModal let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    
    <h5 class="fw-bold mx-3">
      Détails du Prélèvement
    </h5>

    <div class="row m-3">

      <!-- Code échantillon -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Code échantillon :</div>
        <p>{{ form.get('sampleCode')?.value }}</p>
      </div>

      <!-- Type -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Type d'échantillon :</div>
        <p>{{ form.get('typeSampleName')?.value }}</p>
      </div>

      <!-- Client -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Client :</div>
        <p>{{ form.get('clientName')?.value }}</p>
      </div>

      <!-- Lot -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Lot :</div>
        <p>{{ form.get('batchReference')?.value }}</p>
      </div>

      <!-- Terrain -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Terrain :</div>
        <p>{{ form.get('terrainVarPlante')?.value }}</p>
      </div>

      <!-- Prélevé par -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Prélevé par :</div>
        <p>{{ form.get('collectedByUsername')?.value }}</p>
      </div>

      <!-- Quantité -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Quantité prélevée :</div>
        <p>{{ form.get('qtePre')?.value }}</p>
      </div>

      <!-- Date collecte -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Date de collecte :</div>
        <p>{{ form.get('collectionDate')?.value |  date:'dd/MM/yyyy HH:mm' }}</p>
      </div>

      <!-- Température -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Température prélèvement :</div>
        <p>{{ form.get('temperaturePrelevement')?.value }}</p>
      </div>

      <!-- Date production -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Date de production :</div>
        <p>{{ form.get('dateProduction')?.value | date:'shortDate' }}</p>
      </div>

      <!-- DLC -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Date limite consommation :</div>
        <p>{{ form.get('dateLimiteConsommation')?.value | date:'shortDate' }}</p>
      </div>

    </div>

  </mat-card>
</ng-template>



<!-- Menu with Checkboxes -->
<mat-menu #menu="matMenu">
    <div class="scrollable-menu shadow-lg bg-body">
        <mat-checkbox [checked]="displayedColumns.length == columns.length" (change)=" handleIsAllColsSelected($event)"
                      (click)="$event.stopPropagation()">Tous
        </mat-checkbox>
        @for (col of columns; track $index) {
            <div>
                <mat-checkbox [value]="col"
                              [checked]="displayedColumns.includes(col) || displayedColumns.length == columns.length"
                              (click)="$event.stopPropagation(); onSelectionChange(col)">
                    {{ columnLabels[col] || col }}
                </mat-checkbox>
            </div>
        }
    </div>

</mat-menu>
